<template>
    <div class="small-nav">
        <div class="small-nav__primary">
            <div class="view-options" aria-label="Catalog view mode">
                <div class="view-mode-switch">
                    <button
                        type="button"
                        class="view-mode-button list-option"
                        :class="{'active': getLayout == 'simple'}"
                        :aria-pressed="getLayout == 'simple' ? 'true' : 'false'"
                        @click="openSimpleView">
                        <span class="icon icon-list"></span>
                        <span class="view-mode-copy">List</span>
                    </button>
                    <button
                        type="button"
                        class="view-mode-button album-option"
                        :class="{'active': getLayout == 'advanced'}"
                        :aria-pressed="getLayout == 'advanced' ? 'true' : 'false'"
                        @click="openSliderView">
                        <span class="icon icon-gauge"></span>
                        <span class="view-mode-copy">Details</span>
                    </button>
                </div>
                <div class="compat-mode-button" @click="compatMode(!getCompatibleMode)">
                    <span class="compat-mode-copy">
                        Compatible Only
                        <input :checked="getCompatibleMode == true" type="checkbox" />
                    </span>
                </div>
            </div>
        </div>
        <div class="small-nav__count" aria-live="polite">
            <span class="small-nav__count-number">{{ shownItemsCount.toLocaleString() }}</span>
            <span>{{ shownItemsCount === 1 ? 'item' : 'items' }} shown</span>
        </div>
        <div class="small-nav__sort">
            <div v-if="filterClicked" class="dropdown small-nav__dropdown">
                <div
                    v-click-outside="hide"
                    class="gixcore-dropdown small-nav__sort-trigger"
                    @keydown.esc.stop.prevent="closeSortMenu"
                    :class="{'clicked':sortByClicked}">
                    <div class="sort-by-content sort-by-content--current">
                        <button
                            ref="sortButton"
                            type="button"
                            class="small-nav__sort-button"
                            :title="sortOptionDescription(activeSortOption)"
                            :aria-label="'Sort parts. Current order: ' + sortOptionLabel(activeSortOption, true)"
                            :aria-expanded="sortByClicked ? 'true' : 'false'"
                            aria-haspopup="listbox"
                            @click.prevent.stop="toggleSortMenu">
                            <svg class="small-nav__sort-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M3 4h9M3 8h6M3 12h3M15 3v13m-3-3 3 3 3-3" /></svg>
                            <span>{{ sortOptionLabel(activeSortOption, true) }}</span>
                            <span class="icon icon-chevron-small-down" aria-hidden="true"></span>
                        </button>
                    </div>
                    <div v-if="sortByClicked" class="small-nav__sort-menu" role="listbox">
                        <div class="sort-by-content" v-for="option in visibleSortOptions" :key="option.id">
                            <a
                                href="#"
                                role="option"
                                :title="sortOptionDescription(option)"
                                :aria-selected="option.id == activeSortOption.id ? 'true' : 'false'"
                                :class="{'is-chosen': option.id == activeSortOption.id}"
                                @click.prevent.stop="selectSortOption(option)">
                                {{ sortOptionLabel(option, false) }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters}    from 'vuex'
import ClickOutside                 from 'vue-click-outside'
import { SHOW_PRICES }              from '../../config'
import { EventBus }                 from '../../eventBus'


export default {
    name: 'smallnav',
    props: ["viewModes", "items"],
    directives: {
        ClickOutside
    },
    data() {
        return {
            type:                   '',
            item: '',
            filterClicked:          true,
            sortByClicked:          false
        }
    },
    computed: {
        ...mapGetters([
            'getLayout',
            'getCompatibleMode',
            'getSortBy',
            'getFetchedItems'
        ]),
        shownItemsCount(){
            return Array.isArray(this.items) ? this.items.length : 0
        },
        visibleSortOptions(){
            return (this.getSortBy || []).filter((option) => SHOW_PRICES || !this.isPriceSort(option))
        },
        activeSortOption(){
            var visible = this.visibleSortOptions
            var active = visible.find((option) => option.chosen)
            return active || visible[0] || { id: 0, name: 'Performance: High to Low' }
        }
    },
    methods: {
        ...mapActions([
            'setLayout',
            'compatMode',
            'updateSortBy',
            'sortItems'
        ]),
        getType(){
            this.type = this.$route.path.replace(/\\|\/builder\//g,'') 
            return this.type
        },
        getInitialSliderId(){
            if(!this.items || !this.items.length){
                return null
            }
            var chosen = this.items.find((item) => item && item.chosen)
            return chosen ? chosen.id : this.items[0].id
        },
        openSimpleView(){
            var query = Object.assign({}, this.$route.query)
            delete query.view
            delete query.id
            delete query.redir
            this.$router.replace({ query: query }).catch(()=>{})
            this.setLayout('simple')
        },
        openSliderView(){
            var query = Object.assign({}, this.$route.query, { view: 'slider' })
            var id = this.getInitialSliderId()
            if(id !== null && id !== undefined){
                query.id = id
            }
            var navigate = this.$route.query && this.$route.query.view == 'slider' ? this.$router.replace : this.$router.push
            navigate.call(this.$router, { query: query }).catch(()=>{})
            this.setLayout('advanced')
        },
        toggleSortMenu () {
            this.sortByClicked = !this.sortByClicked;
        },
        closeSortMenu(){
            this.hide()
            this.$nextTick(() => { if(this.$refs.sortButton){ this.$refs.sortButton.focus() } })
        },
        show () {
            this.sortByClicked = true;
        },
        selectSortOption(option){
            this.sortItems({option: option, items: this.getFetchedItems || this.items})
            this.hide()
        },
        sortOptionLabel(option, compact){
            var name = option && option.name ? option.name : ''
            if(name == 'Perf/$: High to Low'){
                return compact ? 'Value: High to Low' : 'Value (performance per dollar): High to Low'
            }
            if(name == 'Perf/$: Low to High'){
                return compact ? 'Value: Low to High' : 'Value (performance per dollar): Low to High'
            }
            return name
        },
        sortOptionDescription(option){
            var name = option && option.name ? option.name : ''
            if(name.indexOf('Perf/$:') === 0){
                return this.sortOptionLabel(option, false)
                    + '. This is price-adjusted value; the Performance rank shown on each card excludes price.'
            }
            if(name.indexOf('Performance:') === 0){
                return name + '. This uses the same absolute performance score as the Performance rank on each card.'
            }
            return name
        },
        isPriceSort(option){
            return !!(option && option.name && option.name.indexOf('Price:') === 0)
        },
        hide () { 
            if (this.sortByClicked==true ){
            this.sortByClicked = false;}
        }
    },
    mounted(){
        EventBus.$on('builderListItemOpened', this.hide)
    },
    beforeDestroy(){
        EventBus.$off('builderListItemOpened', this.hide)
    },
}
</script>
<style scoped>
.small-nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.9rem;
    min-height: 32px;
    margin: 0;
    padding: 0;
    position: relative;
    /* Keep the entire sort control above catalog cards and their action buttons.
       A high z-index on the menu alone cannot escape a lower parent stacking
       context. Feedback dialogs remain above this layer. */
    z-index: 11000;
    isolation: isolate;
}

.small-nav__primary {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    min-width: 0;
    flex-wrap: wrap;
}

.small-nav__count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    min-height: 28px;
    margin-left: auto;
    padding: 0 0.62rem;
    border: 1px solid rgba(67, 72, 87, 0.62);
    border-radius: 999px;
    background: rgba(18, 21, 29, 0.48);
    color: rgba(170, 180, 202, 0.72);
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.04em;
    line-height: 1;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
}

.small-nav__count-number {
    font-weight: 900;
}

.compat-mode-button {
    display: inline-flex;
    align-items: center;
    min-height: 28px;
    padding: 0 0.65rem;
    border: none;
    border-radius: 999px;
    background: rgba(18, 21, 29, 0.72);
    transition: border-color 0.2s, background 0.2s, color 0.2s;
}

.compat-mode-button:hover {
    cursor: pointer;
}

.compat-mode-copy {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: #9198aa;
    font-size: 12px !important;
    font-weight: 600;
    line-height: 1;
}

.compat-mode-button input {
    cursor: pointer;
    margin-left: 0;
}

input[type='checkbox'] {
    width: 16px !important;
    height: 16px !important;
    margin-top:-2px;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    outline: 1px solid #434857;
    border-radius: 1px;
    box-shadow: none;
    font-size: 1em;
    text-align: center;
    line-height: 1em;
    background: #191B20;
    vertical-align: text-bottom !important;
    padding-top: 2px;
    transition: 0.3s;
}

input[type='checkbox']:checked:after {
    content: '✔';
    color: #00bc8c;
}

.compat-mode-button:hover span{
    color: #1997c6;
}

.compat-mode-button:hover span input[type='checkbox'] {
    outline: 1px solid #1997c6;
    opacity: 0.8;
}

.view-options {
    display: inline-flex;
    align-items: center;
    gap: 0.42rem;
    min-height: 28px;
    margin: 0;
    text-align: left;
}

.view-mode-switch {
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    height: 32px;
    min-height: 32px;
    padding: 2px;
    border-radius: 10px;
    background: rgba(10, 14, 22, 0.56);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025);
}

.view-mode-button {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    flex: 0 0 auto;
    box-sizing: border-box;
    min-width: 72px;
    min-height: 26px;
    padding: 0 9px;
    border: 1px solid rgba(67, 72, 87, 0.82);
    border-radius: 7px;
    outline: none;
    appearance: none;
    background:
        linear-gradient(180deg, rgba(18, 24, 35, 0.86), rgba(7, 10, 15, 0.86));
    color: #8d96a8;
    cursor: pointer;
    font-family: inherit;
    font-size: 12px !important;
    font-weight: 800;
    letter-spacing: 0.01em;
    line-height: 1;
    white-space: nowrap;
    text-decoration: none;
    text-transform: none;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.025),
        0 7px 18px rgba(0, 0, 0, 0.12);
    transition: border-color 160ms ease, background 160ms ease, color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.list-option {
    min-width: 76px;
}

.album-option {
    min-width: 80px;
}

.view-mode-button .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
    margin: 0 !important;
    color: inherit;
    font-size: 12px !important;
    line-height: 1;
}

.view-mode-copy {
    display: block;
    color: inherit;
    font-size: 12px !important;
    font-weight: 800;
    line-height: 1;
    white-space: nowrap;
}

.view-mode-button:hover,
.view-mode-button:focus {
    border-color: rgba(25, 151, 198, 0.66);
    background:
        linear-gradient(180deg, rgba(17, 38, 50, 0.92), rgba(8, 20, 30, 0.92));
    color: #c9edf8;
}

.view-mode-button.active {
    border-color: rgba(25, 151, 198, 0.96);
    background:
        linear-gradient(180deg, rgba(18, 64, 82, 0.9), rgba(6, 29, 41, 0.92));
    color: #20c8f8;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.05),
        inset 0 -1px 0 rgba(25, 151, 198, 0.16),
        0 0 18px rgba(25, 151, 198, 0.16);
}

.notification {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    margin: -0.72rem -0.44rem 0 -0.22rem;
    padding: 0 4px;
    border-radius: 50%;
    background-color: #1997c6;
    color: white;
    font-size: 9px !important;
    text-align: center;
}

.list-option:hover, .album-option:hover{
    transform: translateY(-1px);
}

.small-nav__sort {
    position: relative;
    margin-left: 0;
    min-width: 0;
}

.small-nav__dropdown {
    margin-top: 0;
}

.small-nav__sort-trigger {
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 148px;
    min-height: 32px;
    margin: 0;
    padding: 0;
    border: 1px solid rgba(75, 86, 110, 0.7);
    border-radius: 5px;
    background: rgba(18, 21, 29, 0.72) !important;
}

.small-nav__sort-trigger.clicked {
    z-index: 120;
    border: 1px solid rgba(25, 151, 198, 0.5);
    background: rgba(12, 17, 25, 0.92) !important;
}

.sort-by-content {
    display: block;
    font-size: 13px;
}

.sort-by-content a {
    display: block;
    width: auto;
    padding-right: 0;
}

.small-nav__sort-button {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    width: 100%;
    min-height: 30px;
    padding: 5px 9px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: #aeb8c8;
    font: inherit;
    font-size: 12px;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;
}

.small-nav__sort-button:hover,
.small-nav__sort-trigger.clicked .small-nav__sort-button {
    color: #d8e3f0;
}
.small-nav__sort-button:focus-visible { outline: 2px solid #1997c6; outline-offset: 2px; }
.small-nav__sort-icon { flex: 0 0 16px; width: 16px; height: 16px; stroke: #45c5f2; stroke-width: 1.5; stroke-linecap: round; stroke-linejoin: round; }
.small-nav__sort-button .icon { margin-left: auto; }
.sort-by-content--current { width: 100%; }

.small-nav__sort-menu {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 2;
    display: grid;
    gap: 3px;
    min-width: 224px;
    padding: 6px;
    border: 1px solid rgba(75, 86, 110, 0.84);
    border-radius: 10px;
    background:
        linear-gradient(180deg, rgba(16, 21, 31, 0.98), rgba(7, 10, 15, 0.98)),
        #080a0f;
    box-shadow:
        0 18px 42px rgba(0, 0, 0, 0.52),
        inset 0 0 0 1px rgba(255, 255, 255, 0.025);
}

.small-nav__sort-menu .sort-by-content a {
    padding: 7px 10px;
    border-radius: 7px;
    color: #c2c8d6;
    text-align: left;
    white-space: nowrap;
    text-decoration: none;
    transition: background 140ms ease, color 140ms ease;
}

.small-nav__sort-menu .sort-by-content a:hover {
    background: rgba(25, 151, 198, 0.14);
    color: #eaf6fb;
}

.small-nav__sort-menu .sort-by-content a.is-chosen {
    color: #1997c6;
}

@media (min-width: 761px) and (max-width: 940px) {
    .small-nav {
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
        min-height: 0;
        max-height: none !important;
        margin-left: 0;
        margin-bottom: 0.55rem;
    }

    .small-nav__primary {
        flex: 1 1 auto;
        width: auto;
        min-width: 0;
        gap: 0.5rem;
        flex-wrap: nowrap;
    }

    .view-options {
        width: auto;
        justify-content: flex-start;
        gap: 0.35rem;
        min-width: 0;
    }

    .view-mode-switch {
        flex: 0 1 auto;
        min-width: 0;
    }

    .view-mode-button {
        padding: 0 0.55rem;
    }

    .list-option {
        min-width: 76px;
    }

    .album-option {
        min-width: 80px;
    }

    .compat-mode-button {
        margin-left: auto;
        min-height: 30px;
        padding: 0 0.64rem;
    }

    .compat-mode-copy {
        font-size: 12px !important;
    }

    .small-nav__sort {
        width: auto;
        margin-left: auto;
    }

    .small-nav__count {
        display: none;
    }

    .small-nav__sort-trigger {
        justify-content: flex-start;
        min-height: 30px;
        width: auto;
        min-width: 0;
        padding: 0;
        font-size: 12px;
    }

    .small-nav__sort-menu {
        right: 0;
    }
}

@media (max-width: 760px) {
    .small-nav {
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
        min-height: 0;
        max-height: none !important;
        margin-left: 0;
        margin-bottom: 0.55rem;
    }

    .small-nav__primary {
        flex: 1 1 auto;
        width: auto;
        gap: 0.5rem;
    }

    .view-options {
        width: auto;
        justify-content: flex-start;
        gap: 0.35rem;
        min-width: 0;
    }

    .view-mode-switch {
        flex: 0 1 auto;
        min-width: 0;
    }

    .view-mode-button {
        padding: 0 0.55rem;
    }

    .list-option {
        min-width: 76px;
    }

    .album-option {
        min-width: 80px;
    }

    .compat-mode-button {
        margin-left: auto;
        min-height: 30px;
        padding: 0 0.64rem;
    }

    .compat-mode-copy {
        font-size: 12px !important;
    }

    .small-nav__sort {
        width: auto;
        margin-left: auto;
    }

    .small-nav__sort-trigger {
        min-height: 30px;
        width: auto;
        min-width: 0;
        padding: 0;
        font-size: 12px;
    }

    .small-nav__sort-menu {
        right: 0;
    }
}

@media (max-width: 520px) {
    .small-nav {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        align-items: center;
    }

    .small-nav__primary {
        grid-column: 1 / -1;
        width: 100%;
    }

    .small-nav__sort { grid-column: 1; grid-row: 2; margin-left: 0; }
    .small-nav__count { grid-column: 2; grid-row: 2; }
    .small-nav__sort-button { white-space: normal; text-align: left; }

    .view-options {
        width: 100%;
        justify-content: flex-start;
        overflow-x: auto;
        padding-bottom: 2px;
    }

    .view-mode-switch {
        flex: 0 0 auto;
    }

    .view-mode-button {
        padding: 0 0.5rem;
    }

    .list-option {
        min-width: 72px;
    }

    .album-option {
        min-width: 76px;
    }

    .view-mode-copy {
        font-size: 11px;
    }

    .small-nav__sort-trigger {
        width: 100%;
    }

    .small-nav__sort-menu {
        right: auto;
        left: 0;
        width: max-content;
        max-width: calc(100vw - 32px);
        min-width: 0;
    }
    .small-nav__sort-menu .sort-by-content a { white-space: normal; }
}
</style>
